function ratingModel({ id, isSelected = false }) {
  return { id, isSelected };
}

/**
 * This provides a configurable array length of `ratingModel` objects, defaulting to 11 (0-10).
 * @param {number} range
 * @param {number} preselect provide a selected rating
 * @returns {Array<string, boolean>}
 */
export function ratingListModel(preselect, range = 11) {
  return [...Array(range).keys()].map((id) => {
    const isSelected = preselect === id;
    return ratingModel({ id, isSelected });
  });
}
